import React, { useEffect, useState } from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

const SNACK_ANCHOR = { vertical: "top", horizontal: "right" };

/**
 * V2 feedback — MUI Snackbar + Alert. Replaces V1 SuccessMessage / ErrorMessage API.
 */
export function AppToast({
  message,
  severity = "info",
  className,
  reopenKey,
  autoHideDuration,
  onClose: onCloseProp,
}) {
  const duration =
    autoHideDuration ?? (severity === "error" ? 6000 : 4000);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (message) setOpen(true);
  }, [message, reopenKey]);

  const handleClose = (_, reason) => {
    if (reason === "clickaway") return;
    setOpen(false);
    onCloseProp?.();
  };

  return (
    <Snackbar
      className={className}
      open={open && Boolean(message)}
      autoHideDuration={duration}
      onClose={handleClose}
      anchorOrigin={SNACK_ANCHOR}
      disablePortal={false}
      sx={{ zIndex: 10000 }}
    >
      <Alert
        onClose={handleClose}
        severity={severity}
        variant="filled"
        sx={{
          width: "100%",
          alignItems: "center",
          fontFamily: (t) => t.typography.fontFamily,
          boxShadow: (t) => t.shadows[4],
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
}

export function SuccessMessage({ successMessage, className, dataset }) {
  return (
    <AppToast
      message={successMessage}
      severity="success"
      className={className}
      reopenKey={dataset}
    />
  );
}

export function ErrorMessage({ error = "", className, datetimestamp }) {
  return (
    <AppToast
      message={error}
      severity="error"
      className={className}
      reopenKey={datetimestamp}
    />
  );
}
